var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$freeParticulier() || _vm.form.projets.length > 0 ? _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_vm._v("\n    Projets\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "border-2 border-gray-600 border-opacity-25 border-dashed rounded-2xl xl:mx-28 xxl:mx-40 mb-10 p-5"
  }, [_c('div', {
    staticClass: "text-lg text-indigo-600 font-normal text-center"
  }, [_vm._v("\n      Durée totale des accompagnements\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-center"
  }, [_c('br'), _vm._v("\n      Total: " + _vm._s(_vm.totalDuration.total[0].h) + "h\n      " + _vm._s((_vm.totalDuration.total[0].min < 10 ? '0' : '') + _vm.totalDuration.total[0].min) + "min réel\n      "), _c('div', {
    staticClass: "inline-flex text-gray-600"
  }, [_vm._v("\n        (" + _vm._s(_vm.totalDuration.total[1].h) + "h\n        " + _vm._s((_vm.totalDuration.total[1].min < 10 ? '0' : '') + _vm.totalDuration.total[1].min) + "min estimées)\n      ")]), _vm._v(" "), _c('br'), _vm._v("\n      Personnel: " + _vm._s(_vm.totalDuration.perso[0].h) + "h\n      " + _vm._s((_vm.totalDuration.perso[0].min < 10 ? '0' : '') + _vm.totalDuration.perso[0].min) + "min réel\n      "), _c('div', {
    staticClass: "inline-flex text-gray-600"
  }, [_vm._v("\n        (" + _vm._s(_vm.totalDuration.perso[1].h) + "h\n        " + _vm._s((_vm.totalDuration.perso[1].min < 10 ? '0' : '') + _vm.totalDuration.perso[1].min) + "min estimées)\n      ")]), _vm._v(" "), _c('br'), _vm._v("\n      Socio-professionnel: " + _vm._s(_vm.totalDuration.socio[0].h) + "h\n      " + _vm._s((_vm.totalDuration.socio[0].min < 10 ? '0' : '') + _vm.totalDuration.socio[0].min) + "min réel\n      "), _c('div', {
    staticClass: "inline-flex text-gray-600"
  }, [_vm._v("\n        (" + _vm._s(_vm.totalDuration.socio[1].h) + "h\n        " + _vm._s((_vm.totalDuration.socio[1].min < 10 ? '0' : '') + _vm.totalDuration.socio[1].min) + "min estimées)\n      ")]), _vm._v(" "), _c('br'), _vm._v("\n      Professionnel: " + _vm._s(_vm.totalDuration.pro[0].h) + "h\n      " + _vm._s((_vm.totalDuration.pro[0].min < 10 ? '0' : '') + _vm.totalDuration.pro[0].min) + "min réel\n      "), _c('div', {
    staticClass: "inline-flex text-gray-600"
  }, [_vm._v("\n        (" + _vm._s(_vm.totalDuration.pro[1].h) + "h\n        " + _vm._s((_vm.totalDuration.pro[1].min < 10 ? '0' : '') + _vm.totalDuration.pro[1].min) + "min estimées)\n      ")])])]), _vm._v(" "), _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) ? _c('add-button', {
    staticClass: "mx-5 md:mx-15 2xl:mx-20",
    attrs: {
      "libelle": "Ajouter un projet"
    },
    on: {
      "add": function ($event) {
        return _vm.addProject();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.form.projets.length > 0 ? _c('div', [_c('list-grid', {
    ref: "listProjects",
    attrs: {
      "list-items": _vm.form.projets,
      "is-accordion-items": true
    },
    on: {
      "displayNum": function (num) {
        _vm.projectDisplayed = num;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-3 md:col-start-2 col-span-5 md:col-span-3"
        }, [_vm._v("\n          Période\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-2"
        }, [_vm._v("\n          Type\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-2"
        }, [_vm._v("\n          Intitulé\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-1"
        }, [_vm._v("\n          Temps\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-2"
        }, [_vm._v("\n          Etat\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-1"
        })];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('icon', {
          staticClass: "text-pink-600 col-span-2 md:col-span-1 place-self-center transform transition-transform ease-in-out duration-300",
          class: {
            'rotate-90': _vm.projectDisplayed == num
          },
          attrs: {
            "name": "chevron-right"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-3 text-base font-normal justify-self-start"
        }, [item.min_debut_accompagnement_projet != '' && item.min_debut_accompagnement_projet != null ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.min_debut_accompagnement_projet).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.min_debut_accompagnement_projet).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.min_debut_accompagnement_projet).getFullYear()) + "\n          ")]) : _vm._e(), _vm._v(" "), item.min_debut_accompagnement_projet != '' && item.min_debut_accompagnement_projet != null && item.max_fin_accompagnement_projet != '' && item.max_fin_accompagnement_projet != null ? _c('span', [_vm._v("\n            -\n          ")]) : _vm._e(), _vm._v(" "), item.max_fin_accompagnement_projet != '' && item.max_fin_accompagnement_projet != null ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.max_fin_accompagnement_projet).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.max_fin_accompagnement_projet).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.max_fin_accompagnement_projet).getFullYear()) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-2 text-base font-normal justify-self-start"
        }, [_c('tag', {
          attrs: {
            "libelle": item.type_projet,
            "theme-color": item.type_projet == 'Professionnel' ? 'indigo' : item.type_projet == 'Personnel' ? 'pink' : item.type_projet == 'Socio-professionnel' ? 'teal' : 'default'
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-2 text-base font-normal justify-self-start"
        }, [_vm._v("\n          " + _vm._s(item.intitule_projet) + "\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden lg:block md:col-span-1 text-base font-normal justify-self-start"
        }, [item.total_temps_accompagnement > 0 ? _c('span', [_vm._v("\n            " + _vm._s(item.total_temps_accompagnement.toFixed(0)) + "h\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:inline-block md:col-span-2"
        }, [_c('span', {
          staticClass: "text-base font-normal",
          class: {
            'text-indigo-600 ': item.etat_decision_projet == 'Soumis à l\'étude',
            'text-pink-600': item.etat_decision_projet == 'Refusé',
            'text-teal-600 ': item.etat_decision_projet == 'Programmé'
          }
        }, [_vm._v("\n            " + _vm._s(item.etat_decision_projet) + "\n          ")])]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-1"
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('circle-button', {
          attrs: {
            "icon": "download",
            "label": "Exporter le projet en PDF"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.exportToPDF(item);
            }
          }
        }) : _vm._e()], 1)];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('div', {
          staticClass: "col-span-full text-base text-indigo-600 font-normal"
        }, [_vm._v("\n            PROJET\n          ")]), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "type_projet",
            "libelle": "Type de projet",
            "size": "3",
            "necessary": true,
            "value": item.type_projet,
            "datas": [{
              value: 'Personnel'
            }, {
              value: 'Professionnel'
            }, {
              value: 'Socio-professionnel'
            }]
          },
          on: {
            "input": function (newValue) {
              item.type_projet = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "intitule_projet",
            "libelle": "Intitulé du projet",
            "necessary": true,
            "value": item.intitule_projet
          },
          on: {
            "input": function (newValue) {
              item.intitule_projet = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "objectifs_projet",
            "libelle": "Objectifs ",
            "necessary": true,
            "size": "4",
            "value": item.objectifs_projet
          },
          on: {
            "input": function (newValue) {
              item.objectifs_projet = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "comment_projet",
            "libelle": "Commentaire",
            "necessary": false,
            "size": "4",
            "value": item.comment_projet
          },
          on: {
            "input": function (newValue) {
              item.comment_projet = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "moyens_projet",
            "libelle": "Moyens mis en oeuvre",
            "necessary": false,
            "size": "4",
            "value": item.moyens_projet
          },
          on: {
            "input": function (newValue) {
              item.moyens_projet = newValue;
            }
          }
        }), _vm._v(" "), _vm._l(item.referents, function (referent, indexReferent) {
          return _c('div', {
            key: referent.nom_referent,
            staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-10",
            class: {
              'border-b w-full pb-5 border-gray-600': _vm.$isMobile() && indexReferent < item.referents.length - 1
            }
          }, [item.referents.length > 1 ? _c('delete-button', {
            staticClass: "col-span-1 lg:pt-8",
            attrs: {
              "libelle": _vm.$isMobile() ? 'Supprimer ce référent' : ''
            },
            on: {
              "del": function ($event) {
                return _vm.deleteReferent(item.referents, indexReferent);
              }
            }
          }) : _vm._e(), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "accompagnateur_projet",
              "libelle": "Référent accompagnateur",
              "necessary": true,
              "value": referent.accompagnateur_projet
            },
            on: {
              "input": function (newValue) {
                referent.accompagnateur_projet = newValue;
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-4",
            attrs: {
              "name": "debut_accompagnement_projet",
              "necessary-date": true,
              "libelle": "Date de début d'accompagnement du projet",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": referent.debut_accompagnement_projet
            },
            on: {
              "input": function (newValue) {
                if (referent.fin_accompagnement_projet == '' && referent.fin_accompagnement_projet == null || _vm.$verifyDates({
                  debut: newValue,
                  fin: referent.fin_accompagnement_projet
                })) {
                  referent.debut_accompagnement_projet = newValue;
                  _vm.setMinDateDebutReferent(num);
                } else {
                  _vm.badDates();
                  referent.debut_accompagnement_projet = '';
                }
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-4",
            attrs: {
              "name": "fin_accompagnement_projet",
              "necessary-date": true,
              "libelle": "Date de fin d'accompagnement du projet",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": referent.fin_accompagnement_projet
            },
            on: {
              "input": function (newValue) {
                if (referent.debut_accompagnement_projet == '' && referent.debut_accompagnement_projet == null || _vm.$verifyDates({
                  debut: referent.debut_accompagnement_projet,
                  fin: newValue
                })) {
                  referent.fin_accompagnement_projet = newValue;
                  _vm.setMaxDateDebutReferent(num);
                } else {
                  _vm.badDates();
                  referent.fin_accompagnement_projet = '';
                }
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "col-start-1 col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
          }, [_c('div', {
            staticClass: "col-span-full md:col-span-3",
            class: {
              'lg:col-start-2': item.referents.length > 1
            }
          }, [_c('info-bulle-hover', {
            attrs: {
              "name": "tempsestimetooltip",
              "libelle": "Temps d'accompagnement estimé",
              "is-display-tooltip": _vm.isEstimatedTimeTooltipDisplay
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "text-sm text-gray-600 font-normal truncate w-full mb-2",
            domProps: {
              "innerHTML": _vm._s('Temps d\'accomp. estimé')
            },
            on: {
              "mouseover": function ($event) {
                _vm.isEstimatedTimeTooltipDisplay = true;
              },
              "mouseleave": function ($event) {
                _vm.isEstimatedTimeTooltipDisplay = false;
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "w-full flex"
          }, [_c('div', {
            staticClass: "w-1/2 mr-2"
          }, [_c('input-select', {
            attrs: {
              "name": 'temps_accompagnement_estime_hour' + indexReferent,
              "necessary": true,
              "datas": _vm.nbheuresPossible,
              "value": referent.temps_accompagnement_estime_hour,
              "libelle": "",
              "placeholder": "h",
              "fixed-text": " h"
            },
            on: {
              "input": function (newValue) {
                referent.temps_accompagnement_estime_hour = newValue;
              }
            }
          })], 1), _vm._v(" "), _c('div', {
            staticClass: "w-1/2 ml-2"
          }, [_c('input-select', {
            attrs: {
              "name": 'temps_accompagnement_estime_minute' + indexReferent,
              "necessary": true,
              "datas": _vm.nbminutesPossible,
              "value": referent.temps_accompagnement_estime_minute,
              "libelle": "",
              "placeholder": "min",
              "fixed-text": " min"
            },
            on: {
              "input": function (newValue) {
                referent.temps_accompagnement_estime_minute = newValue;
              }
            }
          })], 1)])], 1), _vm._v(" "), _c('div', {
            staticClass: "col-span-full md:col-span-3"
          }, [_c('info-bulle-hover', {
            attrs: {
              "name": "tempsreeltooltip",
              "libelle": "Temps d'accompagnement réel",
              "is-display-tooltip": _vm.isRealTimeTooltipDisplay
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "text-sm text-gray-600 font-normal truncate w-full mb-2",
            domProps: {
              "innerHTML": _vm._s('Temps d\'accomp. réel')
            },
            on: {
              "mouseover": function ($event) {
                _vm.isRealTimeTooltipDisplay = true;
              },
              "mouseleave": function ($event) {
                _vm.isRealTimeTooltipDisplay = false;
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "w-full flex"
          }, [_c('div', {
            staticClass: "w-1/2 mr-2"
          }, [_c('input-select', {
            attrs: {
              "name": 'temps_accompagnement_reel_hour' + indexReferent,
              "necessary": true,
              "datas": _vm.nbheuresPossible,
              "value": referent.temps_accompagnement_reel_hour,
              "libelle": "",
              "placeholder": "h",
              "fixed-text": " h"
            },
            on: {
              "input": function (newValue) {
                referent.temps_accompagnement_reel_hour = newValue;
                _vm.setTotalTempsAccompagnement(num);
              }
            }
          })], 1), _vm._v(" "), _c('div', {
            staticClass: "w-1/2 ml-2"
          }, [_c('input-select', {
            attrs: {
              "name": 'temps_accompagnement_reel_minute' + indexReferent,
              "necessary": true,
              "datas": _vm.nbminutesPossible,
              "value": referent.temps_accompagnement_reel_minute,
              "libelle": "",
              "placeholder": "min",
              "fixed-text": " min"
            },
            on: {
              "input": function (newValue) {
                referent.temps_accompagnement_reel_minute = newValue;
                _vm.setTotalTempsAccompagnement(num);
              }
            }
          })], 1)])], 1)])], 1);
        }), _vm._v(" "), _vm.$can(_vm.page + '_edit', _vm.idpass) || _vm.page === _vm.Constants.PAGE_NEOPASS_FORM_DOCUMENTS ? _c('div', {
          staticClass: "col-span-full w-max-content w-max cursor-pointer flex hover:font-medium",
          on: {
            "click": function ($event) {
              return _vm.addReferent(num);
            }
          }
        }, [_c('span', {
          staticClass: "plus-button 2xl:h-10 2xl:w-10"
        }, [_c('icon', {
          attrs: {
            "name": "plus"
          }
        })], 1), _vm._v(" "), _c('span', {
          staticClass: "text-base text-gray-600 ml-3 mt-1.5 flex-initial"
        }, [_vm._v("\n              Ajouter un référent accompagnateur\n            ")])]) : _c('div', {
          staticClass: "col-span-full w-max-content w-max cursor-not-allowed flex"
        }, [_c('span', {
          staticClass: "plus-button 2xl:h-10 2xl:w-10"
        }, [_c('icon', {
          attrs: {
            "name": "plus"
          }
        })], 1), _vm._v(" "), _c('span', {
          staticClass: "text-base text-gray-600 ml-3 mt-1.5 flex-initial"
        }, [_vm._v("\n              Ajouter un référent accompagnateur\n            ")])]), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "etat_decision_projet",
            "libelle": "Etat de la décision",
            "size": "3",
            "value": item.etat_decision_projet,
            "datas": [{
              value: 'Soumis à l\'étude'
            }, {
              value: 'Refusé'
            }, {
              value: 'Programmé'
            }]
          },
          on: {
            "input": function (newValue) {
              item.etat_decision_projet = newValue;
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full flex text-base text-indigo-600 font-normal"
        }, [_c('p', [_vm._v("STAGE, FORMATION ET ACCOMPAGNEMENT")]), _vm._v(" "), _c('info-bulle', {
          attrs: {
            "libelle": "ex : rendez-vous psychologue",
            "is-libelle-input": true
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-full w-max mb-10 relative"
        }, [_c('add-button', {
          attrs: {
            "libelle": "Ajouter un stage, une formation ou un accompagnement",
            "with-dropdown": true
          },
          on: {
            "add": _vm.displayDropdownMenu
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-out duration-150",
            "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
            "leave-active-class": "ease-in duration-200",
            "leave-class": "opacity-100 translate-y-0 sm:scale-100",
            "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          }
        }, [_vm.dropDownMenu ? _c('div', {
          directives: [{
            name: "clickOutside",
            rawName: "v-clickOutside",
            value: _vm.forceHide,
            expression: "forceHide"
          }],
          staticClass: "z-20 absolute right-0 top-8 mt-1 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
        }, [_c('div', {
          staticClass: "mx-5 my-3 text-left"
        }, _vm._l(_vm.typePeriodes, function (type, indexPeriode) {
          return _c('div', {
            key: indexPeriode,
            staticClass: "cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900",
            on: {
              "click": function ($event) {
                return _vm.addPeriode(num, type);
              }
            }
          }, [_vm._v("\n                    " + _vm._s(type) + "\n                  ")]);
        }), 0)]) : _vm._e()])], 1), _vm._v(" "), _vm.form.projets[num].periodes.length > 0 ? _c('div', {
          staticClass: "col-span-full"
        }, [_c('div', {
          staticClass: "text-lg text-gray-600 h-16 2xl:h-24 grid grid-cols-12 gap-x-4 place-content-center"
        }, [_c('div', {
          staticClass: "col-start-3 col-span-4 md:col-start-2 md:col-span-2 xl:col-start-2 xl:col-span-3"
        }, [_vm._v("\n                Période\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-3"
        }, [_vm._v("\n                Type\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-4 md:col-span-3 xl:col-span-2 xxl:col-span-3"
        }, [_vm._v("\n                Intitulé\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-3 xxl:col-span-2"
        }, [_vm._v("\n                Etat\n              ")])]), _vm._v(" "), _vm._l(item.periodes, function (per, i) {
          return _c('div', {
            key: i,
            staticClass: "even:bg-gray-200 even:bg-opacity-50"
          }, [_c('div', {
            staticClass: "h-16 lg:h-24 2xl:h-32 hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center items-center cursor-pointer",
            class: {
              'bg-indigo-200 border-l-2 border-indigo-600': _vm.periodeDisplayed == i
            },
            on: {
              "click": function ($event) {
                return _vm.displayPeriode(i);
              }
            }
          }, [_c('icon', {
            staticClass: "col-span-2 md:col-span-1 text-pink-600 place-self-center transform transition-transform ease-in-out duration-300",
            class: {
              'rotate-90': _vm.periodeDisplayed == i
            },
            attrs: {
              "name": "chevron-right"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "col-span-4 md:col-span-2 xl:col-span-3 text-base"
          }, [per.debut_periode ? _c('span', [_vm._v("\n                    " + _vm._s(('0' + new Date(per.debut_periode).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(per.debut_periode).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(per.debut_periode).getFullYear()) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('span', {
            staticClass: "hidden lg:inline"
          }, [_vm._v("-")]), _vm._v(" "), per.debut_periode && !per.fin_periode ? _c('span', {
            staticClass: "hidden lg:inline"
          }, [_vm._v("\n                    En cours\n                  ")]) : _vm._e(), _vm._v(" "), per.fin_periode ? _c('span', {
            staticClass: "hidden lg:inline"
          }, [_vm._v("\n                    " + _vm._s(('0' + new Date(per.fin_periode).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(per.fin_periode).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(per.fin_periode).getFullYear()) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "hidden md:block md:col-span-3"
          }, [_c('tag', {
            attrs: {
              "libelle": per.type,
              "theme-color": per.type == 'Stage' ? 'orange' : per.type == 'Formation' ? 'white' : 'teal'
            }
          })], 1), _vm._v(" "), _c('div', {
            staticClass: "col-span-4 md:col-span-3 xl:col-span-2 xxl:col-span-3 text-base justify-self-start"
          }, [_vm._v("\n                  " + _vm._s(per.intitule_periode) + "\n                ")]), _vm._v(" "), _c('div', {
            staticClass: "hidden md:block md:col-span-3 xxl:col-span-2"
          }, [_c('span', {
            staticClass: "py-1 text-base",
            class: {
              'text-indigo-600': per.etat_decision == 'Soumise à l\'étude' || per.etat_decision == 'Soumis à l\'étude',
              'text-pink-600': per.etat_decision == 'Refusée' || per.etat_decision == 'Refusé',
              'text-teal-600 ': per.etat_decision == 'Programmée' || per.etat_decision == 'Programmé'
            }
          }, [_vm._v("\n                    " + _vm._s(per.etat_decision) + "\n                  ")])])], 1), _vm._v(" "), _c('transition-group', {
            attrs: {
              "enter-active-class": "ease-out duration-300",
              "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
              "leave-active-class": "ease-in duration-200",
              "leave-class": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }
          }, [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.periodeDisplayed === i,
              expression: "periodeDisplayed === i"
            }],
            key: 'stage' + i,
            attrs: {
              "id": `periode${i}`
            }
          }, [per.type === 'Stage' ? _c('div', {
            staticClass: "bg-white px-5 pt-5 md:px-15 md:pt-15 grid grid-cols-12 gap-x-4 gap-y-10"
          }, [_c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "intitule_periode",
              "necessary": true,
              "libelle": "Intitulé du stage",
              "value": per.intitule_periode
            },
            on: {
              "input": function (newValue) {
                per.intitule_periode = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "nom_structure",
              "necessary": true,
              "libelle": "Nom de la structure d'accueil",
              "value": per.nom_structure
            },
            on: {
              "input": function (newValue) {
                per.nom_structure = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "localisation_stage",
              "necessary": true,
              "libelle": "Localisation",
              "value": per.localisation_stage
            },
            on: {
              "input": function (newValue) {
                per.localisation_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "referent_stage",
              "necessary": true,
              "libelle": "Référent / interlocuteur principal",
              "value": per.referent_stage
            },
            on: {
              "input": function (newValue) {
                per.referent_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-3",
            attrs: {
              "name": "debut_periode",
              "necessary-date": true,
              "libelle": "Date de début du stage",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": per.debut_periode
            },
            on: {
              "input": function (newValue) {
                if (per.fin_periode == '' && per.fin_periode == null || _vm.$verifyDates({
                  debut: newValue,
                  fin: per.fin_periode
                })) {
                  per.debut_periode = newValue;
                  _vm.sortPeriodes(num);
                } else {
                  _vm.badDates();
                  per.debut_periode = '';
                }
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-3",
            attrs: {
              "name": "fin_periode",
              "necessary-date": true,
              "libelle": "Date de fin du stage",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": per.fin_periode
            },
            on: {
              "input": function (newValue) {
                if (per.debut_periode == '' && per.debut_periode == null || _vm.$verifyDates({
                  debut: per.debut_periode,
                  fin: newValue
                })) {
                  per.fin_periode = newValue;
                  _vm.sortPeriodes(num);
                } else {
                  _vm.badDates();
                  per.fin_periode = '';
                }
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "duree_stage",
              "necessary": true,
              "libelle": "Durée (en h)",
              "value": per.duree_stage
            },
            on: {
              "input": function (newValue) {
                per.duree_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "type_stage",
              "necessary": true,
              "libelle": "Type de stage",
              "size": "3",
              "value": per.type_stage,
              "datas": [{
                value: 'Interne'
              }, {
                value: 'Externe'
              }]
            },
            on: {
              "input": function (newValue) {
                per.type_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "milieu_stage",
              "necessary": true,
              "libelle": "Stage en milieu",
              "size": "3",
              "value": per.milieu_stage,
              "datas": [{
                value: 'Ordinaire'
              }, {
                value: 'Protégé'
              }]
            },
            on: {
              "input": function (newValue) {
                per.milieu_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "caracteristique_stage",
              "necessary": true,
              "libelle": "Caracteristiques du stage",
              "size": "3",
              "value": per.caracteristique_stage,
              "datas": [{
                value: 'Application'
              }, {
                value: 'Observation'
              }]
            },
            on: {
              "input": function (newValue) {
                per.caracteristique_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "etat_decision",
              "necessary": true,
              "libelle": "Etat de la décision",
              "size": "3",
              "value": per.etat_decision,
              "datas": [{
                value: 'Soumis à l\'étude'
              }, {
                value: 'Refusé'
              }, {
                value: 'Programmé'
              }]
            },
            on: {
              "input": function (newValue) {
                per.etat_decision = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text-area', {
            staticClass: "lg:col-start-1 md:col-span-6",
            attrs: {
              "name": "objectifs_resultats",
              "necessary": true,
              "libelle": "Objectifs / Résultats attendus",
              "size": "4",
              "value": per.objectifs_resultats
            },
            on: {
              "input": function (newValue) {
                per.objectifs_resultats = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text-area', {
            staticClass: "md:col-span-6",
            attrs: {
              "name": "commentaire_stage",
              "libelle": "Commentaires",
              "size": "4",
              "value": per.commentaire_stage
            },
            on: {
              "input": function (newValue) {
                per.commentaire_stage = newValue;
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "col-span-full w-max-content w-max cursor-pointer flex hover:font-medium",
            on: {
              "click": function ($event) {
                return _vm.deletePeriode(item.periodes, i);
              }
            }
          }, [_c('span', {
            staticClass: "minus-button 2xl:h-10 2xl:w-10"
          }, [_c('icon', {
            attrs: {
              "name": "close"
            }
          })], 1), _vm._v(" "), _c('span', {
            staticClass: "text-gray-600 text-base ml-3 mt-1.5 mb-10 flex-initial"
          }, [_vm._v("\n                        Supprimer ce stage\n                      ")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.periodeDisplayed === i,
              expression: "periodeDisplayed === i"
            }],
            key: 'formation' + i
          }, [per.type === 'Formation' ? _c('div', {
            staticClass: "bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
          }, [_c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "intitule_periode",
              "necessary": true,
              "libelle": "Intitulé de la formation",
              "value": per.intitule_periode
            },
            on: {
              "input": function (newValue) {
                per.intitule_periode = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "organisme_formation",
              "necessary": true,
              "libelle": "Organisme de formation",
              "value": per.organisme_formation
            },
            on: {
              "input": function (newValue) {
                per.organisme_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "localisation_formation",
              "necessary": true,
              "libelle": "Localisation",
              "value": per.localisation_formation
            },
            on: {
              "input": function (newValue) {
                per.localisation_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "referent_formation",
              "necessary": true,
              "libelle": "Référent / Interlocuteur principal",
              "value": per.referent_formation
            },
            on: {
              "input": function (newValue) {
                per.referent_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-3",
            attrs: {
              "name": "debut_periode",
              "necessary-date": true,
              "libelle": "Date de début de formation",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": per.debut_periode
            },
            on: {
              "input": function (newValue) {
                if (per.fin_periode == '' && per.fin_periode == null || _vm.$verifyDates({
                  debut: newValue,
                  fin: per.fin_periode
                })) {
                  per.debut_periode = newValue;
                  _vm.sortPeriodes(num);
                } else {
                  _vm.badDates();
                  per.debut_periode = '';
                }
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-3",
            attrs: {
              "name": "fin_periode",
              "necessary-date": true,
              "libelle": "Date de fin de formation",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": per.fin_periode
            },
            on: {
              "input": function (newValue) {
                if (per.debut_periode == '' && per.debut_periode == null || _vm.$verifyDates({
                  debut: per.debut_periode,
                  fin: newValue
                })) {
                  per.fin_periode = newValue;
                  _vm.sortPeriodes(num);
                } else {
                  _vm.badDates();
                  per.fin_periode = '';
                }
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "duree_formation",
              "necessary": true,
              "libelle": "durée (en h)",
              "value": per.duree_formation
            },
            on: {
              "input": function (newValue) {
                per.duree_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "type_formation",
              "necessary": true,
              "libelle": "Type de formation",
              "value": per.type_formation,
              "datas": [{
                value: 'Interne'
              }, {
                value: 'Externe'
              }]
            },
            on: {
              "input": function (newValue) {
                per.type_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "modalites_formation",
              "necessary": true,
              "libelle": "Modalités",
              "value": per.modalites_formation,
              "datas": [{
                value: 'Présentiel'
              }, {
                value: 'E-learning'
              }]
            },
            on: {
              "input": function (newValue) {
                per.modalites_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "dispositifs_formation",
              "necessary": true,
              "libelle": "Dispositifs retenus",
              "value": per.dispositifs_formation,
              "datas": [{
                value: 'Plan de Formation Cat 1 ou 2 '
              }, {
                value: 'PP'
              }, {
                value: 'CPF'
              }, {
                value: 'CEP'
              }, {
                value: 'CIF'
              }, {
                value: 'VAE'
              }, {
                value: 'BC'
              }, {
                value: 'RSFP'
              }, {
                value: 'Autres'
              }]
            },
            on: {
              "input": function (newValue) {
                per.dispositifs_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('transition', {
            attrs: {
              "enter-active-class": "ease-in duration-300",
              "enter-class": "opacity-0",
              "leave-active-class": "ease-out duration-300",
              "leave-to-class": "opacity-0"
            }
          }, [per.dispositifs_formation === 'Autres' ? _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "dispositifs_formation_precis",
              "necessary": true,
              "libelle": "Précisez (si autre)",
              "value": per.dispositifs_formation_precis
            },
            on: {
              "input": function (newValue) {
                per.dispositifs_formation_precis = newValue;
              }
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "formation_suivie",
              "necessary": true,
              "libelle": "Formation suivie au titre de",
              "value": per.formation_suivie,
              "datas": [{
                value: 'Formation de professionnalisation'
              }, {
                value: 'Formation d\'intégration'
              }, {
                value: 'Formation de perfectionnement'
              }, {
                value: 'Formation de préparation aux concours et examens professionnels'
              }, {
                value: 'Formation personnelle'
              }, {
                value: 'Autre'
              }]
            },
            on: {
              "input": function (newValue) {
                per.formation_suivie = newValue;
              }
            }
          }), _vm._v(" "), _c('transition', {
            attrs: {
              "enter-active-class": "ease-in duration-300",
              "enter-class": "opacity-0",
              "leave-active-class": "ease-out duration-300",
              "leave-to-class": "opacity-0"
            }
          }, [per.formation_suivie === 'Autre' ? _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "necessary": true,
              "name": "dispositifs_formation_precis",
              "libelle": "Précisez (si autre)",
              "value": per.formation_suivie_precis
            },
            on: {
              "input": function (newValue) {
                per.formation_suivie_precis = newValue;
              }
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "etat_decision",
              "necessary": true,
              "libelle": "Etat de la décision",
              "value": per.etat_decision,
              "datas": [{
                value: 'Programmée'
              }, {
                value: 'Soumise à l\'étude'
              }, {
                value: 'Refusée'
              }]
            },
            on: {
              "input": function (newValue) {
                per.etat_decision = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text-area', {
            staticClass: "lg:col-start-1 md:col-span-6",
            attrs: {
              "name": "objectifs_formation",
              "necessary": true,
              "libelle": "Objectifs pédagogiques",
              "size": "4",
              "value": per.objectifs_formation
            },
            on: {
              "input": function (newValue) {
                per.objectifs_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text-area', {
            staticClass: "md:col-span-6",
            attrs: {
              "name": "commentaire_formation",
              "libelle": "Commentaires",
              "size": "4",
              "value": per.commentaire_formation
            },
            on: {
              "input": function (newValue) {
                per.commentaire_formation = newValue;
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "col-span-3 w-max-content w-max cursor-pointer flex hover:font-semibold",
            on: {
              "click": function ($event) {
                return _vm.deletePeriode(item.periodes, i);
              }
            }
          }, [_c('span', {
            staticClass: "minus-button"
          }, [_c('icon', {
            attrs: {
              "name": "close"
            }
          })], 1), _vm._v(" "), _c('span', {
            staticClass: "text text-gray-600 text-sm ml-3 mt-1.5 mb-10 flex-initial"
          }, [_vm._v("\n                        Supprimer cette formation\n                      ")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.periodeDisplayed === i,
              expression: "periodeDisplayed === i"
            }],
            key: 'accompagnement' + i
          }, [per.type === 'Accompagnement' ? _c('div', {
            staticClass: "bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
          }, [_c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "intitule_periode",
              "necessary": true,
              "libelle": "Intitulé",
              "value": per.intitule_periode
            },
            on: {
              "input": function (newValue) {
                per.intitule_periode = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "organisme_accompagnement",
              "necessary": true,
              "libelle": "Organisme",
              "value": per.organisme_accompagnement
            },
            on: {
              "input": function (newValue) {
                per.organisme_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "localisation_accompagnement",
              "necessary": true,
              "libelle": "Localisation",
              "value": per.localisation_accompagnement
            },
            on: {
              "input": function (newValue) {
                per.localisation_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "referent_accompagnement",
              "necessary": true,
              "libelle": "Référent / Interlocuteur principal",
              "value": per.referent_accompagnement
            },
            on: {
              "input": function (newValue) {
                per.referent_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-3",
            attrs: {
              "name": "debut_periode",
              "necessary-date": true,
              "libelle": "Date de début de l'accompagnement",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": per.debut_periode
            },
            on: {
              "input": function (newValue) {
                if (per.fin_periode == '' && per.fin_periode == null || _vm.$verifyDates({
                  debut: newValue,
                  fin: per.fin_periode
                })) {
                  per.debut_periode = newValue;
                  _vm.sortPeriodes(num);
                } else {
                  _vm.badDates();
                  per.debut_periode = '';
                }
              }
            }
          }), _vm._v(" "), _c('date-picker', {
            staticClass: "col-span-full md:col-span-3",
            attrs: {
              "name": "fin_periode",
              "necessary-date": true,
              "libelle": "Date de fin de l'accompagnement",
              "format": "dd/MM/yyyy",
              "initialview": "year",
              "value": per.fin_periode
            },
            on: {
              "input": function (newValue) {
                if (per.debut_periode == '' && per.debut_periode == null || _vm.$verifyDates({
                  debut: per.debut_periode,
                  fin: newValue
                })) {
                  per.fin_periode = newValue;
                  _vm.sortPeriodes(num);
                } else {
                  _vm.badDates();
                  per.fin_periode = '';
                }
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "duree_accompagnement",
              "necessary": true,
              "libelle": "durée (en h)",
              "value": per.duree_accompagnement
            },
            on: {
              "input": function (newValue) {
                per.duree_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "type_accompagnement",
              "necessary": true,
              "libelle": "Type d'accompagnement",
              "value": per.type_accompagnement,
              "datas": [{
                value: 'Interne'
              }, {
                value: 'Externe'
              }]
            },
            on: {
              "input": function (newValue) {
                per.type_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "modalites_accompagnement",
              "necessary": true,
              "libelle": "Modalités",
              "value": per.modalites_accompagnement,
              "datas": [{
                value: 'Présentiel'
              }, {
                value: 'E-learning'
              }]
            },
            on: {
              "input": function (newValue) {
                per.modalites_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "dispositifs_accompagnement",
              "necessary": true,
              "libelle": "Dispositifs retenus",
              "value": per.dispositifs_accompagnement,
              "datas": [{
                value: 'Plan de Formation Cat 1 ou 2 '
              }, {
                value: 'PP'
              }, {
                value: 'CPF'
              }, {
                value: 'CEP'
              }, {
                value: 'CIF'
              }, {
                value: 'VAE'
              }, {
                value: 'BC'
              }, {
                value: 'RSFP'
              }, {
                value: 'Autres'
              }]
            },
            on: {
              "input": function (newValue) {
                per.dispositifs_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('transition', {
            attrs: {
              "enter-active-class": "ease-in duration-300",
              "enter-class": "opacity-0",
              "leave-active-class": "ease-out duration-300",
              "leave-to-class": "opacity-0"
            }
          }, [per.dispositifs_accompagnement === 'Autres' ? _c('input-text', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "dispositifs_accompagnement_precis",
              "necessary": true,
              "libelle": "Précisez (si autre)",
              "value": per.dispositifs_accompagnement_precis
            },
            on: {
              "input": function (newValue) {
                per.dispositifs_accompagnement_precis = newValue;
              }
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
            staticClass: "md:col-span-3",
            attrs: {
              "name": "etat_decision",
              "necessary": true,
              "libelle": "Etat de la décision",
              "value": per.etat_decision,
              "datas": [{
                value: 'Programmée'
              }, {
                value: 'Soumise à l\'étude'
              }, {
                value: 'Refusée'
              }]
            },
            on: {
              "input": function (newValue) {
                per.etat_decision = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text-area', {
            staticClass: "lg:col-start-1 md:col-span-6",
            attrs: {
              "name": "objectifs_accompagnement",
              "necessary": true,
              "libelle": "Objectifs pédagogiques",
              "size": "4",
              "value": per.objectifs_accompagnement
            },
            on: {
              "input": function (newValue) {
                per.objectifs_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('input-text-area', {
            staticClass: "md:col-span-6",
            attrs: {
              "name": "commentaire_accompagnement",
              "libelle": "Commentaires",
              "size": "4",
              "value": per.commentaire_accompagnement
            },
            on: {
              "input": function (newValue) {
                per.commentaire_accompagnement = newValue;
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "col-span-3 w-max-content w-max cursor-pointer flex hover:font-semibold",
            on: {
              "click": function ($event) {
                return _vm.deletePeriode(item.periodes, i);
              }
            }
          }, [_c('span', {
            staticClass: "minus-button"
          }, [_c('icon', {
            attrs: {
              "name": "close"
            }
          })], 1), _vm._v(" "), _c('span', {
            staticClass: "text text-gray-600 text-sm ml-3 mt-1.5 mb-10 flex-initial"
          }, [_vm._v("\n                        Supprimer cet accompagnement\n                      ")])])], 1) : _vm._e()])])], 1);
        })], 2) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "col-span-full grid grid-cols-12 gap-y-10"
        }, [_c('div', {
          staticClass: "col-span-6"
        }, [_c('date-picker', {
          attrs: {
            "name": 'date_commentary' + num,
            "libelle": "Date du résultat",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.date_resultat
          },
          on: {
            "input": function (newValue) {
              item.date_resultat = newValue;
            }
          }
        })], 1), _vm._v(" "), _c('input-text-area', {
          staticClass: "col-start-1 col-span-full",
          attrs: {
            "name": 'resultat' + num,
            "libelle": "Résultat du projet",
            "necessary": false,
            "size": "4",
            "value": item.resultat
          },
          on: {
            "input": function (newValue) {
              item.resultat = newValue;
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-full w-max-content w-max cursor-pointer flex text-gray-900 hover:text-gray-600 items-center",
          on: {
            "click": function ($event) {
              return _vm.deleteItem(_vm.form.projets, num);
            }
          }
        }, [_c('span', {
          staticClass: "minus-button 2xl:h-10 2xl:w-10"
        }, [_c('icon', {
          attrs: {
            "name": "close"
          }
        })], 1), _vm._v(" "), _c('span', {
          staticClass: "text-base ml-3"
        }, [_vm._v(" Supprimer ce projet ")])])], 2)];
      }
    }], null, false, 790711158)
  })], 1) : _vm._e()], 1) : _c('div', [_c('h3', {
    staticClass: "my-15 w-full"
  }, [_vm._v("\n    Aucun projet\n  ")]), _vm._v(" "), _vm.$hasAtLeastOneGuest() ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), !_vm.$hasAtLeastOneGuest() ? _c('div', [_c('div', {
    staticClass: "text-gray-600 text-lg text-center"
  }, [_c('p', [_vm._v("\n        Veuillez ajouter un\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'PermissionsGuests'
      }
    }
  }, [_c('span', {
    staticClass: "cursor-pointer text-indigo-500 underline"
  }, [_vm._v("invité")])]), _vm._v("\n        pour accéder à cette évaluation.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-gray-600 text-lg text-center"
  }, [_c('p', [_vm._v("Il n'y a aucun projet enregistré.")])]);

}]

export { render, staticRenderFns }